import Div100vh from 'react-div-100vh';
import { colors, media, spacing } from '@lamimed/pantheon';
import { math } from 'polished';
import styled, { css } from 'styled-components';

import { tabbarHeight } from 'components/Tabbar/styles';

import {
  mobileWrapperHeaderHeight,
  tabletWrapperHeaderHeight,
} from './containers/Header/styles';
import { navigationHeight } from './containers/Navigation/styles';

export const Container = styled(Div100vh)`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr;
  grid-template-areas:
    'nav'
    'header'
    'body';

  ${media.lessThan('desktop')`
    height: 100% !important;
  `};

  ${media.greaterThan('desktop')`
    overflow-y: auto;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas:
      'nav header'
      'nav body';
  `};

  a {
    text-decoration: none;
  }
`;

type BodyProps = {
  haveTabbar: boolean;
  paddingBottom?: string;
};

const mobileHeaderNavigationHeight = math(
  `${navigationHeight} + ${mobileWrapperHeaderHeight}`,
);

const tabletHeaderNavigationHeight = math(
  `${navigationHeight} + ${tabletWrapperHeaderHeight}`,
);

function heightWithMarginVariants(
  haveTabbar: BodyProps['haveTabbar'],
  headerNavigationHeight: string,
) {
  if (haveTabbar) {
    return css`
      // NOTE: dvh fallback
      min-height: calc(100vh - (${headerNavigationHeight} + ${tabbarHeight}));

      min-height: calc(100dvh - (${headerNavigationHeight} + ${tabbarHeight}));
      margin-top: calc(${headerNavigationHeight} + ${tabbarHeight});
    `;
  }

  return css`
    // NOTE: dvh fallback
    min-height: calc(100vh - ${headerNavigationHeight});

    min-height: calc(100dvh - ${headerNavigationHeight});
    margin-top: ${headerNavigationHeight};
  `;
}

export const Body = styled.div<BodyProps>`
  ${({ haveTabbar, paddingBottom = spacing.medium }) => css`
    grid-area: body;
    background-color: ${colors.neutral_light};
    padding: ${spacing.medium};
    padding-bottom: ${paddingBottom};

    ${heightWithMarginVariants(haveTabbar, mobileHeaderNavigationHeight)};

    ${media.greaterThan('tablet')`
      ${heightWithMarginVariants(haveTabbar, tabletHeaderNavigationHeight)};
    `};

    ${media.greaterThan('desktop')`
      min-height: initial;
      overflow-y: auto;
      margin-top: initial;
    `};
  `};
`;
